import React, { ComponentProps, PropsWithChildren } from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import { PILL_HEIGHT } from './Pill'
import { rem } from 'polished'

const PillBox = styled(LoadingBox)`
  height: ${PILL_HEIGHT};
  border-radius: ${props => props.theme.borderRadius.round};
`

interface Props extends ComponentProps<typeof LoadingBox> {
  /**
   * in pixels
   */
  width: number
}

function PillLoadingBox(props: PropsWithChildren<Props>) {
  const { children, width, ...loadingBoxProps } = props

  return <PillBox {...loadingBoxProps} style={{ ...loadingBoxProps.style, width: rem(width) }}>
    {children}
  </PillBox>
}

export default PillLoadingBox
